interface Column<T> {
  header: string;
  render: (row: T) => React.ReactNode;
}

interface Props<T> {
  columns: Column<T>[];
  rows: T[];
  total: number;
  limit: number;
  offset: number;
  onPageChange: (nextOffset: number) => void;
  rowKey?: (row: T, index: number) => string;
}

export function PaginatedTable<T>({ columns, rows, total, limit, offset, onPageChange, rowKey }: Props<T>) {
  if (total === 0) {
    return <p style={{ color: "var(--dim)" }}>Nothing in this range.</p>;
  }

  const start = offset + 1;
  const end = Math.min(offset + rows.length, total);

  return (
    <div>
      <table className="data-table">
        <thead>
          <tr>{columns.map((c) => <th key={c.header}>{c.header}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={rowKey ? rowKey(row, i) : i}>
              {columns.map((c) => <td key={c.header}>{c.render(row)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: 10, display: "flex", alignItems: "center", gap: 10, color: "var(--slate)", fontSize: 12 }}>
        <button
          onClick={() => onPageChange(Math.max(0, offset - limit))}
          disabled={offset === 0}
        >
          Prev
        </button>
        <span>{start}–{end} of {total}</span>
        <button
          onClick={() => onPageChange(offset + limit)}
          disabled={offset + rows.length >= total}
        >
          Next
        </button>
      </div>
    </div>
  );
}
